/** Age-6–7 focused activity groups. No older mission IDs or gates changed. */
export const ROBOT_ARTIST_EXPLORERS_FLOW = {
  "explorers-robot-prelude": [
    {
      "id": "explorers-prelude-1",
      "title": "The mystery",
      "purpose": "Watch the story and find a visible clue",
      "blockIds": [
        "explorers-story-prelude",
        "explorers-first-clue",
        "explorers-first-theory",
        "explorers-swan-prelude",
        "explorers-prelude-gate"
      ]
    }
  ],
  "explorers-robot-wonder": [
    {
      "id": "explorers-wonder-1",
      "title": "New evidence",
      "purpose": "Open the reveal and decide what you think now",
      "blockIds": [
        "explorers-first-idea-again",
        "explorers-robot-reveal",
        "explorers-surprise",
        "explorers-goal",
        "explorers-swan-wonder",
        "explorers-wonder-gate"
      ]
    }
  ],
  "explorers-robot-explore": [
    {
      "id": "explorers-explore-1",
      "title": "Find the parts",
      "purpose": "Compare real parts and 3D",
      "blockIds": [
        "explorers-explore-story",
        "explorers-parts-gallery",
        "explorers-parts-threejs",
        "explorers-found-three",
        "explorers-job-prediction",
        "explorers-swan-parts",
        "explorers-parts-gate"
      ]
    }
  ],
  "explorers-robot-understand": [
    {
      "id": "explorers-understand-1",
      "title": "Power and wobble",
      "purpose": "Predict what makes the robot wiggle",
      "blockIds": [
        "explorers-understand-story",
        "explorers-circuit-gallery",
        "explorers-switch-guess",
        "explorers-wobble-guess",
        "explorers-motion-sequence",
        "explorers-swan-understand",
        "explorers-understand-gate"
      ]
    }
  ],
  "explorers-robot-apply": [
    {
      "id": "explorers-apply-1",
      "title": "Build your robot",
      "purpose": "Use the 3D guide with a grown-up",
      "blockIds": [
        "explorers-apply-safety",
        "explorers-assembly-pwo",
        "explorers-build-check"
      ]
    },
    {
      "id": "explorers-apply-2",
      "title": "Try it",
      "purpose": "Predict and record a real test",
      "blockIds": [
        "explorers-first-prediction",
        "explorers-first-test",
        "explorers-swan-build",
        "explorers-apply-gate"
      ]
    }
  ],
  "explorers-robot-test-improve": [
    {
      "id": "explorers-test-improve-1",
      "title": "Plan one change",
      "purpose": "Use your first test to plan safely",
      "blockIds": [
        "explorers-first-test-summary",
        "explorers-one-change",
        "explorers-second-prediction"
      ]
    },
    {
      "id": "explorers-test-improve-2",
      "title": "Observe again",
      "purpose": "Record and compare real outcomes",
      "blockIds": [
        "explorers-second-test",
        "explorers-drawing-comparison",
        "explorers-swan-compare",
        "explorers-test-improve-gate"
      ]
    }
  ],
  "explorers-robot-explain": [
    {
      "id": "explorers-explain-1",
      "title": "How did it draw?",
      "purpose": "Connect the mechanism with your evidence",
      "blockIds": [
        "explorers-explain-gallery",
        "explorers-explain-chain",
        "explorers-evidence-point",
        "explorers-swan-explain",
        "explorers-explain-gate"
      ]
    }
  ],
  "explorers-robot-reflect": [
    {
      "id": "explorers-reflect-1",
      "title": "Look back",
      "purpose": "Remember what you knew and learned",
      "blockIds": [
        "explorers-original-clue",
        "explorers-test-summary",
        "explorers-reflection-choice",
        "explorers-reflection-evidence",
        "explorers-swan-reflect",
        "explorers-reflect-gate"
      ]
    }
  ],
  "explorers-robot-grow": [
    {
      "id": "explorers-grow-1",
      "title": "Your gallery",
      "purpose": "Choose and explain your own result",
      "blockIds": [
        "explorers-gallery-image",
        "explorers-name",
        "explorers-gallery-pick",
        "explorers-gallery-discovery",
        "explorers-swan-grow",
        "explorers-grow-gate"
      ]
    }
  ]
};
